/*
    © 2022 KondaSoft.com. All rights reserved.
    https://www.kondasoft.com
*/

// Init Recently Viewed
const initRecentlyViewed = () => {
    const $el = document.querySelector('[data-recently-viewed]')

    if ($el) {
        let recentlyViewed = JSON.parse(localStorage.getItem('ks_bigstore_recently_viewed')) || []
        const isViewedBefore = recentlyViewed.some((product) => product.id === $el.dataset.productId)

        if (isViewedBefore) {
            recentlyViewed = recentlyViewed.filter((product) => product.id !== $el.dataset.productId)
        }

        if (recentlyViewed.length >= 50) {
            recentlyViewed.shift()
        }

        recentlyViewed.push({
            id: $el.dataset.productId,
            title: $el.dataset.productTitle,
            url: $el.dataset.productUrl,
            compare_at_price: $el.dataset.productCompareAtPrice,
            price: $el.dataset.productPrice,
            price_varies: $el.dataset.productPriceVaries,
            img_src: $el.dataset.productImgSrc,
            img_alt: $el.dataset.productImgAlt,
            viewed_at: Date.now()
        })

        localStorage.setItem('ks_bigstore_recently_viewed', JSON.stringify(recentlyViewed))
    }
}
initRecentlyViewed()

// Load products inside offcanvas
const initOffcanvasRecentlyViewed = () => {
    const offcanvas = document.querySelector('#offcanvas-recently-viewed')
    const recentlyViewed = JSON.parse(localStorage.getItem('ks_bigstore_recently_viewed')) || []

    dayjs.extend(window.dayjs_plugin_relativeTime)

    if (recentlyViewed.length > 0) {
        let html = ''
        recentlyViewed.reverse().forEach((product) => {
            html += `
                <li class="product-list-item">
                    <a href="${product.url}" class="row align-items-center mx-n3 py-3 text-decoration-none">
                        <div class="col-3 px-3">
                            <img 
                                class="product-img img-fluid ${offcanvas.dataset.imgBorder}"
                                src="${window.resizeImage(product.img_src || 'no-image.gif', `${offcanvas.dataset.imgWidth}x${offcanvas.dataset.imgHeight}`, 'center')}"
                                alt="${product.img_alt}" 
                                width="${offcanvas.dataset.imgWidth}"
                                height="${offcanvas.dataset.imgHeight}"
                                loading="lazy">
                        </div>
                        <div class="col-9 px-3">
                            <h5 class="product-title title h6 mb-2">
                                ${product.title}
                            </h5>
                            <p class="product-price-container text-body mb-1">
                                <s class="product-price-compare text-muted me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                    <span class="visually-hidden">
                                        ${offcanvas.dataset.textOldPrice}
                                    </span>
                                    ${window.formatMoney(product.compare_at_price)}
                                </s>
                                <span class="product-price-final">
                                    <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                        ${offcanvas.dataset.textPriceFrom}
                                    </span>
                                    ${window.formatMoney(product.price)}
                                </span>
                            </p>
                            <p class="product-viewed-time small text-muted mb-2 text-muted">
                                ${dayjs().to(dayjs(product.viewed_at))}
                            </p>
                        </div>
                    </a>
                </li>
            `
            offcanvas.querySelector('#offcanvas-recently-viewed-empty').style.display = 'none'
            offcanvas.querySelector('.product-list').innerHTML = html
            offcanvas.querySelector('.product-list').style.display = 'block'
            offcanvas.querySelector('.offcanvas-footer').style.display = 'block'
        })
    } else {
        offcanvas.querySelector('#offcanvas-recently-viewed-empty').style.display = 'block'
        offcanvas.querySelector('.product-list').style.display = 'none'
        offcanvas.querySelector('.offcanvas-footer').style.display = 'none'
    }
}

// Clear list button
const initClearListBtn = () => {
    const $btn = document.querySelector('#offcanvas-recently-viewed-btn-clear')

    $btn?.addEventListener('click', () => {
        localStorage.removeItem('ks_bigstore_recently_viewed')

        initOffcanvasRecentlyViewed()

        setTimeout(() => {
            const bsOffcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-recently-viewed'))
            bsOffcanvas?.hide()
        }, 500)
    })
}
initClearListBtn()

document.querySelector('#offcanvas-recently-viewed')?.addEventListener('show.bs.offcanvas', () => {
    initOffcanvasRecentlyViewed()
})
